import { createBrowserRouter } from "react-router-dom";
import { HomePage } from "./pages/HomePage.js";
import { GalleryPage } from "./pages/GalleryPage.js";
import { UploadPage } from "./pages/UploadPage.js";
import { AdminLoginPage } from "./pages/AdminLoginPage.js";
import { AdminDashboardPage } from "./pages/AdminDashboardPage.js";
import { AdminEventEditPage } from "./pages/AdminEventEditPage.js";
import { NotFoundPage } from "./pages/NotFoundPage.js";

export const router = createBrowserRouter([
  { path: "/", element: <HomePage /> },
  { path: "/m/:token", element: <GalleryPage /> },
  { path: "/m/:token/upload", element: <UploadPage /> },
  { path: "/admin/login", element: <AdminLoginPage /> },
  { path: "/admin", element: <AdminDashboardPage /> },
  { path: "/admin/events/:id", element: <AdminEventEditPage /> },
  { path: "*", element: <NotFoundPage /> },
]);
